
import * as ipxStaticRuntime$WglloEoLvp from '/Users/federicaprincipe/IdeaProjects/Paradigma/pdg-website/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 768,
    "md": 1024,
    "lg": 1440,
    "xl": 1920,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$WglloEoLvp, defaults: {} }
}
        